import React from "react";
import Card from "./Card";
import PrevArrow from "../UI/Icons/PrevArrow";
import NextArrow from "../UI/Icons/NextArrow";
import Line from "./Line";
import Footer from "./Footer";
import Carousel from "react-bootstrap/Carousel";
import { rewardsOverviewText } from "../../settings/Constants";
import GlobalGiving from "images/rewardsOverview/globalGiving.png";
import HandHoldingHeart from "../UI/Icons/HandHoldingHeart";
import HandsHelping from "../UI/Icons/HandsHelping";
import PiggyBank from "../UI/Icons/PiggyBank";
import Hotel from "../UI/Icons/Hotel";
import MapMarker from "../UI/Icons/MapMarker";
import styled, { css } from "styled-components";
import { rem } from "polished";
import PropTypes from "prop-types";

const Section = styled.div`
  margin-top: ${rem("30px")};
`;

const SectionText = styled.div`
  text-align: center;
  color: #343638;
  font-size: ${rem("30px")};
  font-weight: 500;

  ${({ type }) =>
    type == "description" &&
    css`
      margin: ${rem("0px")} auto;
      font-size: ${rem("16px")};
      font-weight: 500;
      max-width: 76%;
    `}
`;

const StyledCarousel = styled(Carousel)`
  margin-top: ${rem("30px")};
  .carousel-control-next,
  .carousel-control-prev {
    width: 3%;
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  .sr-only-focusable:active,
  .sr-only-focusable:focus {
    position: static;
    width: auto;
    height: auto;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }
`;

const CardImage = styled.div`
  width: ${rem("284px")};
  height: ${rem("95px")};

  ${({ image }) => css`
    background-image: url(${image});
    background-size: cover;
    background-position: center;
  `}
`;

const IconContainer = styled.div`
  margin: ${rem("43px")} auto ${rem("0px")};

  > img {
    height: ${rem("50px")};
    width: auto;
  }

  ${({ section }) =>
    section == "cashForACause" &&
    css`
      height: ${rem("37px")};
      margin: ${rem("43px")} auto ${rem("0px")};
      min-width: ${rem("42px")};

      > img {
        height: unset;
        width: ${rem("180px")};
      }
    `}

  ${({ section }) =>
    section == "cashForward" &&
    css`
      height: ${rem("37px")};
      margin: ${rem("43px")} auto ${rem("0px")};
      min-width: ${rem("28px")};
    `}
`;

const CardPrices = styled.div`
  width: ${rem("291px")};
  position: absolute;
  bottom: ${rem("26px")};
`;

const CardText = styled.div`
  text-align: center;
  max-width: ${rem("252px")};
  line-height: ${rem("24px")};
  margin: ${rem("0px")} auto;

  ${({ type }) =>
    type == "title" &&
    css`
      color: #343638;
      font-size: ${rem("16px")};
      font-weight: 500;
      margin-top: ${rem("22px")};
    `}

  ${({ type }) =>
    type == "description" &&
    css`
      color: #666666;
      font-size: ${rem("14px")};
      font-weight: 400;
      margin-top: ${rem("8px")};
      line-height: ${rem("20px")};
    `}

  ${({ type }) =>
    type == "retailPrice" &&
    css`
      color: #666666;
      font-size: ${rem("14px")};
      font-weight: 400;
    `}

  ${({ type }) =>
    type == "memberPrice" &&
    css`
      color: #343638;
      font-size: ${rem("14px")};
      font-weight: 400;
    `}

  ${({ type }) =>
    type == "cashBackDescription" &&
    css`
      max-width: ${rem("220px")};
      font-size: ${rem("14px")};
      font-weight: 400;
      line-height: ${rem("20px")};
      color: #666666;
      margin: ${rem("20px")} auto ${rem("0px")};
    `}
  
  ${({ type }) =>
    type == "cashForACauseDescription" &&
    css`
      max-width: ${rem("220px")};
      font-size: ${rem("14px")};
      font-weight: 400;
      line-height: ${rem("24px")};
      color: #666666;
      margin: ${rem("20px")} auto ${rem("0px")};
    `}

  ${({ type }) =>
    type == "cashForwardDescription" &&
    css`
      max-width: ${rem("220px")};
      font-size: ${rem("14px")};
      font-weight: 400;
      line-height: ${rem("24px")};
      color: #666666;
      margin: ${rem("20px")} auto ${rem("0px")};
    `}
`;

const StyledA = styled.a`
  text-decoration: underline;
  color: #666666;

  &:hover {
    color: #666666;
  }
`;

const Disclaimer = styled.div`
  max-width: ${rem("380px")};
  font-size: ${rem("10px")};
  line-height: ${rem("16px")};
  text-align: center;
  color: #666666;
  margin: ${rem("10px")} auto ${rem("0px")};

  > a {
    text-decoration: underline;
    color: #666666;

    &:hover {
      color: #666666;
    }
  }
`;

const MobileView = ({
  widgetIdentifier,
  includeInstay,
  maxCashback,
  singleVouchers,
  singleRedemptions,
  darkMode,
}) => {
  return (
    <div>
      <Line />
      {includeInstay ? (
        <Section>
          <SectionText>{rewardsOverviewText.instaySection.title}</SectionText>
          <SectionText type="description">
            {rewardsOverviewText.instayCard.description}
          </SectionText>
          <StyledCarousel
            indicators={false}
            prevIcon={<PrevArrow />}
            nextIcon={<NextArrow />}
            interval={100000}
          >
            {singleVouchers.map((instayItem) => (
              <Carousel.Item key={instayItem.voucher_id}>
                <Card type="instay">
                  <CardImage
                    image={instayItem.image_url.replace("//", "http://")}
                  />
                  <CardText type="title">{instayItem.name}</CardText>
                  <CardText type="description">
                    {instayItem.short_description}
                  </CardText>
                  <CardPrices>
                    <CardText type="retailPrice">{`${rewardsOverviewText.instaySection.retailPrice}: $${instayItem.retail_amount}.00`}</CardText>
                    <CardText type="memberPrice">{`${rewardsOverviewText.instaySection.memberPrice}: $${instayItem.amount}.00`}</CardText>
                  </CardPrices>
                </Card>
              </Carousel.Item>
            ))}
          </StyledCarousel>
          <Disclaimer>
            <a href="https://theguestbook.com/faq#In-stay-cash" target="_blank">
              {rewardsOverviewText.learnMore}
            </a>
          </Disclaimer>
          <Line />
        </Section>
      ) : null}
      <Section>
        <SectionText>{rewardsOverviewText.cashbackSection.title}</SectionText>
        <SectionText type="description">
          {rewardsOverviewText.nonInstayCards[0].description}
        </SectionText>
        <StyledCarousel
          indicators={false}
          prevIcon={<PrevArrow />}
          nextIcon={<NextArrow />}
          interval={100000}
        >
          {singleRedemptions.map((redemptionItem) => (
            <Carousel.Item key={redemptionItem.id}>
              <Card>
                <IconContainer>
                  <img
                    alt={redemptionItem.merchant_name}
                    src={"https://" + redemptionItem.image_url}
                  />
                </IconContainer>
                <CardText type="cashBackDescription">
                  {redemptionItem.description
                    .replace(/<\/span>|<p>|<\/p>|<br>|&nbsp;/g, "")
                    .replace(/<span style="font-size: 1rem;">/g, " ")
                    .replace("&amp;", "&")}
                </CardText>
              </Card>
            </Carousel.Item>
          ))}
        </StyledCarousel>
        <Disclaimer>
          <a href="https://theguestbook.com/faq#Rewards" target="_blank">
            {rewardsOverviewText.learnMore}
          </a>
        </Disclaimer>
        <Line />
      </Section>
      <Section>
        <SectionText>
          {rewardsOverviewText.cashForACauseSection.title}
        </SectionText>
        <SectionText type="description">
          {rewardsOverviewText.nonInstayCards[1].description}
        </SectionText>
        <StyledCarousel
          indicators={false}
          prevIcon={<PrevArrow />}
          nextIcon={<NextArrow />}
          interval={100000}
        >
          <Carousel.Item>
            <Card>
              <IconContainer section="cashForACause">
                <img src={GlobalGiving} />
              </IconContainer>
              <CardText type="cashForACauseDescription">
                {rewardsOverviewText.cashForACauseSection.card1.text1}{" "}
                <StyledA href="https://www.globalgiving.org/" target="_blank">
                  GlobalGiving
                </StyledA>
                {rewardsOverviewText.cashForACauseSection.card1.text2}
              </CardText>
            </Card>
          </Carousel.Item>
          <Carousel.Item>
            <Card>
              <IconContainer section="cashForACause">
                <HandsHelping />
              </IconContainer>
              <CardText type="cashForACauseDescription">
                {rewardsOverviewText.cashForACauseSection.card2.text}
              </CardText>
            </Card>
          </Carousel.Item>
          <Carousel.Item>
            <Card>
              <IconContainer section="cashForACause">
                <HandHoldingHeart />
              </IconContainer>
              <CardText type="cashForACauseDescription">
                {rewardsOverviewText.cashForACauseSection.card3.text}
              </CardText>
            </Card>
          </Carousel.Item>
        </StyledCarousel>
        <Line />
      </Section>
      <Section>
        <SectionText>
          {maxCashback}% {rewardsOverviewText.cashForwardSection.title}
        </SectionText>
        <SectionText type="description">
          {rewardsOverviewText.nonInstayCards[2].description}
        </SectionText>
        <StyledCarousel
          indicators={false}
          prevIcon={<PrevArrow />}
          nextIcon={<NextArrow />}
          interval={100000}
        >
          <Carousel.Item>
            <Card>
              <IconContainer section="cashForward">
                <MapMarker />
              </IconContainer>
              <CardText type="cashForwardDescription">
                {rewardsOverviewText.cashForwardSection.card1.text}
              </CardText>
            </Card>
          </Carousel.Item>
          <Carousel.Item>
            <Card>
              <IconContainer section="cashForACause">
                <PiggyBank />
              </IconContainer>
              <CardText type="cashForwardDescription">
                {rewardsOverviewText.cashForwardSection.card2.text}
              </CardText>
            </Card>
          </Carousel.Item>
          <Carousel.Item>
            <Card>
              <IconContainer section="cashForACause">
                <Hotel />
              </IconContainer>
              <CardText type="cashForwardDescription">
                {rewardsOverviewText.cashForwardSection.card3.text}
              </CardText>
            </Card>
          </Carousel.Item>
        </StyledCarousel>
        <Disclaimer>
          {rewardsOverviewText.cashForwardSection.dislaimer}{" "}
          <a href="https://theguestbook.com/faq#Cash-forward" target="_blank">
            {rewardsOverviewText.learnMore}
          </a>
        </Disclaimer>
        <Line />
      </Section>
      <Footer widgetIdentifier={widgetIdentifier} darkMode={darkMode} />
    </div>
  );
};

MobileView.propTypes = {
  widgetIdentifier: PropTypes.string.isRequired,
  includeInstay: PropTypes.bool.isRequired,
  maxCashback: PropTypes.number.isRequired,
  singleVouchers: PropTypes.array.isRequired,
  singleRedemptions: PropTypes.array.isRequired,
};

MobileView.defaultProps = {
  singleVouchers: [],
};

export default MobileView;
